module.exports = __webpack_public_path__ + "20e55a8cc76b084a6480670489711d58.jpg";